import { put, takeLatest } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import { Types, Creators } from '../../reducers/checkout';

function* selectFinancing({ data }) {
  try {
    const { finance, parcelas } = data;
    const financing = {
      carencia: finance.carencia,
      primeiroVencimento: finance.primeiroVencimento,
      parcelas: finance.parcelas.find((item) => item.numeroParcelas === parcelas),
    };

    yield put(Creators.selectFinancingSuccess({ financing }));
  } catch (error) {
    yield put(Creators.selectFinancingError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.SELECT_FINANCING_REQUEST, selectFinancing);
}
